import { useLocation, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useModuleVisibility } from "@/hooks/useModuleVisibility";
import {
  LayoutDashboard, BookOpen, ClipboardCheck, DollarSign,
  HeadphonesIcon, Shield,
} from "lucide-react";
import { cn } from "@/lib/utils";

const studentNavItems = [
  { title: "Dashboard", url: "/dashboard", icon: LayoutDashboard, moduleKey: "dashboard" },
  { title: "Academic", url: "/academic", icon: BookOpen, moduleKey: "academic" },
  { title: "Exams", url: "/examination", icon: ClipboardCheck, moduleKey: "examination" },
  { title: "Finance", url: "/accounting", icon: DollarSign, moduleKey: "accounting" },
  { title: "Services", url: "/student-services", icon: HeadphonesIcon, moduleKey: "student_services" },
  { title: "Discipline", url: "/discipline", icon: Shield, moduleKey: "discipline" },
];

export function BottomNav() {
  const { roles } = useAuth();
  const location = useLocation();
  const isStudent = roles.includes("student");
  const { isModuleVisible } = useModuleVisibility(roles);

  if (!isStudent) return null;

  const visibleItems = studentNavItems.filter(item => isModuleVisible(item.moduleKey));

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 pb-safe">
      <div className="flex items-center justify-around h-16 px-1">
        {visibleItems.map((item) => {
          const active = location.pathname === item.url;
          return (
            <Link
              key={item.url}
              to={item.url}
              className={cn(
                "flex flex-col items-center justify-center gap-0.5 flex-1 h-full text-muted-foreground transition-colors",
                active && "text-primary"
              )}
            >
              <item.icon className="h-5 w-5" />
              <span className="text-[10px] leading-tight font-medium">{item.title}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
